import PropTypes from 'prop-types';
import Select from 'react-select';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import includes from 'lodash/includes';

import { getMarketName } from '../../lib/utils';
import marketActions from '../../actions/markets';
import WrappedSpinner from './wrapped-spinner';

const styles = {
  marketSelect: {
    zIndex: 101,
    marginTop: 8,
  },
};

function BaseMarketMultiSelect({
  markets: propMarkets, handleChange, marketsLoading, value,
}) {
  const markets = propMarkets || [];
  const marketSelections = markets.map((market) => ({
    value: market._id,
    label: getMarketName(market),
  }));
  const selectionValue = marketSelections.filter((selection) => includes(value, selection.value));

  function handleSelection(newSelections) {
    const selections = newSelections || [];
    handleChange(selections.map((selectObject) => selectObject.value));
  }

  return (
    <WrappedSpinner isLoading={marketsLoading}>
      <Select
        value={selectionValue}
        onChange={handleSelection}
        isSearchable
        isMulti
        placeholder="Select Markets"
        options={marketSelections}
        name="selectedMarket"
        style={styles.marketSelect}
      />
    </WrappedSpinner>
  );
}

BaseMarketMultiSelect.defaultProps = {
  markets: [],
  marketsLoading: false,
  value: [],
};
BaseMarketMultiSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  markets: PropTypes.arrayOf(PropTypes.object),
  marketsLoading: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = ({ markets }) => ({
  markets: markets.activeMarkets,
  marketsLoading: markets.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchActiveMarkets: marketActions.fetchActiveMarkets,
}, dispatch);

const MarketMultiSelect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseMarketMultiSelect);

export { MarketMultiSelect, BaseMarketMultiSelect };
